/** Copy for the isolated book-preview and local detail workflow. */
export const modularLibraryBookPreviewCopy = {
  en: {
    detailTitle: 'Book details',
    backToLibrary: 'Back to the library',
    sampleTitle: 'Library prototype',
    sampleNote:
      'This sample uses local book data. Reading status and progress belong only to this prototype.',
    sampleStatus: 'Prototype reading status',
    isbn: 'ISBN {{isbn}}',
    unavailable: 'This sample book is not available.',
  },
  sk: {
    detailTitle: 'Podrobnosti o knihe',
    backToLibrary: 'Späť do knižnice',
    sampleTitle: 'Prototyp knižnice',
    sampleNote:
      'Táto ukážka používa lokálne údaje o knihách. Stav a priebeh čítania patria iba tomuto prototypu.',
    sampleStatus: 'Stav čítania v prototype',
    isbn: 'ISBN {{isbn}}',
    unavailable: 'Táto ukážková kniha nie je dostupná.',
  },
  cs: {
    detailTitle: 'Podrobnosti o knize',
    backToLibrary: 'Zpět do knihovny',
    sampleTitle: 'Prototyp knihovny',
    sampleNote:
      'Tato ukázka používá místní údaje o knihách. Stav a průběh čtení patří pouze tomuto prototypu.',
    sampleStatus: 'Stav čtení v prototypu',
    isbn: 'ISBN {{isbn}}',
    unavailable: 'Tato ukázková kniha není dostupná.',
  },
} as const;
